import React from "react";
import {connect} from "react-redux";

import Button from "components/Button";
import {closeCheckout, getSecureTradingGetJwtString} from "state/school_money/actions";

import "./CardHolderName.css";

class CardHolderName extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      cardHolderName: "",
      isInputValid: true,
      errorMessage: "Field is required"
    }
  }

  onChange = () => {
    const cardHolderName = this.input.value;
    this.setState({cardHolderName});

    if (cardHolderName !== "") {
      this.setState({isInputValid : true})
    }
  }

  refInput = (input) => {
    this.input = input;
  }

  getJWTString = () => {

    const cardHolderName = this.state.cardHolderName;

    if (cardHolderName.trim() === "") {
      this.setState({ isInputValid : false });
      this.setState({ errorMessage : "Field is required" });
      return;
  } else if (!/[a-zA-Z ]/.test(cardHolderName) || /[<>&]/.test(cardHolderName)) {
      this.setState({ isInputValid : false });
      this.setState({ errorMessage : "Invalid name" });
      return;
    }

    this.props.getJWTString(encodeURIComponent(cardHolderName));
  }

  render() {
    const inputClassNames = ["cardholder-name__input"];
    const errorClassNames = ["cardholder-name__error-field"];

    if (!this.state.isInputValid) {
        inputClassNames.push("cardholder-name__input--invalid");
        errorClassNames.push("cardholder-name__error-field--display");
    }

    return (
      <div>
        <div className="cardholder-name__input-container">
          <div className="cardholder-name__input-row">
            <div className="cardholder-name__input-cell">
              <div className="cardholder-name__input-label">Cardholder Name</div>
              <div className={inputClassNames.join(" ")}>
                <input id="cardholder-name_name" ref={this.refInput} placeholder="Cardholder Name" onChange={this.onChange} />
              </div>
              <div className={errorClassNames.join(" ")}>{this.state.errorMessage}</div>
            </div>
          </div>
        </div>
        <div className="cardholder-name__button-container">
          <Button className="cardholder-name__cancel-button" onClick={this.props.onClose}>Cancel</Button>
          <Button className="cardholder-name__next-button" onClick={this.getJWTString}>Next</Button>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  {
    onClose: closeCheckout,
    getJWTString: getSecureTradingGetJwtString
  }
)(CardHolderName);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/secure_trading/CardHolderName.js